export enum MessageStatusTypes {
  ok = 'ok',
  error = 'error',
  cancelled = 'cancelled',
}
